import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '..';

export enum CaptchaStatuses {
  Solved = 'solved',
  Error = 'error',
  Expired = 'expired',
}

export interface IRegistrationState {
  captchaToken?: string;
  captchaStatus?: CaptchaStatuses;
}

const initialState: IRegistrationState = {
  captchaToken: undefined,
  captchaStatus: undefined,
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    setCaptchaToken: (state, {payload}: PayloadAction<string>) => {
      state.captchaToken = payload;
    },
    setCaptchaStatus: (state, {payload}: PayloadAction<CaptchaStatuses>) => {
      state.captchaStatus = payload;
    },
  },
});

export const {setCaptchaToken, setCaptchaStatus} = registrationSlice.actions;

export const selectCaptchaToken = (state: RootState) => state.registration.captchaToken;
export const selectCaptchaStatus = (state: RootState) => state.registration.captchaStatus;

export default registrationSlice.reducer;
